import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const EngagementSection = () => {
  const [activeTab, setActiveTab] = useState('timeline');

  const engagementTimeline = [
    {
      phase: "Initial Consultation",
      duration: "1-2 days",
      activities: [
        "Case material review and conflict check",
        "Preliminary assessment of valuation issues",
        "Engagement letter and fee estimate",
        "Timeline development and milestone planning"
      ],
      deliverables: ["Engagement proposal", "Conflict clearance", "Project timeline"]
    },
    {
      phase: "Discovery & Analysis",
      duration: "2-4 weeks",
      activities: [
        "Document review and data gathering",
        "Management interviews and site visits",
        "Market research and comparable analysis",
        "Financial statement analysis and adjustments"
      ],
      deliverables: ["Data request list", "Interview summaries", "Preliminary findings"]
    },
    {
      phase: "Expert Report Preparation",
      duration: "3-6 weeks",
      activities: [
        "Valuation analysis and calculations",
        "Report drafting and internal review",
        "Supporting schedule preparation",
        "Quality control and peer review"
      ],
      deliverables: ["Expert report", "Supporting schedules", "Executive summary"]
    },
    {
      phase: "Deposition & Trial Prep",
      duration: "1-2 weeks",
      activities: [
        "Deposition preparation and practice",
        "Trial testimony preparation",
        "Visual aid development",
        "Cross-examination preparation"
      ],
      deliverables: ["Deposition outline", "Trial exhibits", "Testimony notes"]
    },
    {
      phase: "Testimony & Support",
      duration: "Ongoing",
      activities: [
        "Deposition testimony",
        "Trial testimony and cross-examination",
        "Post-testimony clarifications",
        "Settlement support if required"
      ],
      deliverables: ["Sworn testimony", "Post-trial support", "Settlement analysis"]
    }
  ];

  const feeStructures = [
    {
      type: "Hourly Billing",
      description: "Traditional hourly billing for all services with detailed time tracking and regular reporting",
      rates: [
        { service: "Partner/Director Level", rate: "$500-650/hour" },
        { service: "Senior Manager Level", rate: "$350-450/hour" },
        { service: "Manager/Analyst Level", rate: "$200-300/hour" },
        { service: "Administrative Support", rate: "$100-150/hour" }
      ],
      advantages: [
        "Transparent billing with detailed time records",
        "Flexibility for scope changes",
        "Pay only for actual time spent"
      ],
      bestFor: "Complex cases with uncertain scope"
    },
    {
      type: "Fixed Fee Arrangements",
      description: "Predetermined fixed fees for specific deliverables with clear scope definition and milestone payments",
      components: [
        { deliverable: "Expert Report Only", fee: "$25,000-75,000" },
        { deliverable: "Report + Deposition", fee: "$35,000-95,000" },
        { deliverable: "Full Trial Support", fee: "$50,000-150,000" }
      ],
      advantages: [
        "Predictable costs for budget planning",
        "Milestone-based payment structure",
        "Incentive for efficient delivery"
      ],
      bestFor: "Standard cases with defined scope"
    }
  ];

  const caseOutcomes = [
    {
      caseType: "Partnership Dissolution",
      jurisdiction: "Dubai Courts",
      outcome: "Favorable Settlement",
      impact: "Our valuation opinion led to a settlement 15% above client\'s initial position",
      keyFactors: ["Comprehensive business analysis", "Strong comparable company data", "Effective testimony preparation"]
    },
    {
      caseType: "Intellectual Property Damages",
      jurisdiction: "DIFC Courts",
      outcome: "Court Acceptance",
      impact: "Judge adopted our damages calculation methodology in final ruling",
      keyFactors: ["Detailed economic analysis", "Industry expertise", "Clear methodology explanation"]
    },
    {
      caseType: "Shareholder Oppression",
      jurisdiction: "Bahrain Commercial Court",
      outcome: "Expert Opinion Upheld",
      impact: "Court rejected opposing expert's valuation, accepting our fair value determination",
      keyFactors: ["Independence demonstration", "Thorough market analysis", "Professional presentation"]
    },
    {
      caseType: "Commercial Dispute",
      jurisdiction: "Qatar Civil Court",
      outcome: "Successful Mediation",
      impact: "Our expert report facilitated successful mediation before trial",
      keyFactors: ["Balanced analysis", "Clear communication", "Settlement support"]
    }
  ];

  return (
    <>
      {/* <section className="py-20 lg:py-28 bg-background">
    //   <div className="max-w-7xl mx-auto px-6 lg:px-8">
    //     <div className="text-center mb-16">
    //       <div className="inline-flex items-center bg-orange-100 text-orange-700 rounded-full px-4 py-2 text-sm font-medium mb-6">
    //         <Icon name="Calendar" size={16} className="mr-2" />
    //         Engagement Process
    //       </div>
          
    //       <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-6">
    //         Structured Litigation Support Engagement
    //       </h2>
          
    //       <p className="text-xl text-text-secondary max-w-3xl mx-auto">
    //         Our systematic engagement process ensures thorough preparation, timely delivery, and successful case outcomes through every phase of litigation support.
    //       </p>
    //     </div>

    //     <div className="flex justify-center mb-12">
    //       <div className="bg-slate-100 rounded-lg p-1 inline-flex">
    //         <button
    //           onClick={() => setActiveTab('timeline')}
    //           className={`px-6 py-3 rounded-md text-sm font-medium transition-all duration-200 ${
    //             activeTab === 'timeline' ?'bg-white text-primary shadow-sm' :'text-text-secondary hover:text-primary'
    //           }`}
    //         >
    //           Engagement Timeline
    //         </button>
    //         <button
    //           onClick={() => setActiveTab('fees')}
    //           className={`px-6 py-3 rounded-md text-sm font-medium transition-all duration-200 ${
    //             activeTab === 'fees' ?'bg-white text-primary shadow-sm' :'text-text-secondary hover:text-primary'
    //           }`}
    //         >
    //           Fee Structures
    //         </button>
    //         <button
    //           onClick={() => setActiveTab('outcomes')}
    //           className={`px-6 py-3 rounded-md text-sm font-medium transition-all duration-200 ${
    //             activeTab === 'outcomes' ?'bg-white text-primary shadow-sm' :'text-text-secondary hover:text-primary'
    //           }`}
    //         >
    //           Case Outcomes
    //         </button>
    //       </div>
    //     </div>

    //     {activeTab === 'timeline' && (
    //       <div className="space-y-8">
    //         {engagementTimeline?.map((phase, index) => (
    //           <div key={index} className="bg-card border border-border rounded-xl p-8 shadow-sm">
    //             <div className="grid lg:grid-cols-3 gap-8">
    //               <div>
    //                 <div className="flex items-center space-x-3 mb-4">
    //                   <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
    //                     <span className="text-orange-600 font-bold text-sm">{index + 1}</span>
    //                   </div>
    //                   <h3 className="text-xl font-semibold text-primary">{phase?.phase}</h3>
    //                 </div>
    //                 <div className="bg-orange-50 border border-orange-200 rounded-lg px-4 py-2 inline-block">
    //                   <span className="text-orange-700 font-medium text-sm">{phase?.duration}</span>
    //                 </div>
    //               </div>

    //               <div>
    //                 <h4 className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
    //                   Key Activities
    //                 </h4>
    //                 <div className="space-y-2">
    //                   {phase?.activities?.map((activity, idx) => (
    //                     <div key={idx} className="flex items-start space-x-2">
    //                       <Icon name="ArrowRight" size={14} className="text-orange-500 flex-shrink-0 mt-0.5" />
    //                       <span className="text-sm text-text-secondary">{activity}</span>
    //                     </div>
    //                   ))}
    //                 </div>
    //               </div>

    //               <div>
    //                 <h4 className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
    //                   Deliverables
    //                 </h4>
    //                 <div className="space-y-2">
    //                   {phase?.deliverables?.map((deliverable, idx) => (
    //                     <div key={idx} className="flex items-center space-x-2">
    //                       <Icon name="CheckCircle" size={14} className="text-emerald-500" />
    //                       <span className="text-sm text-text-secondary">{deliverable}</span>
    //                     </div>
    //                   ))}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     )}

    //     {activeTab === 'fees' && (
    //       <div className="grid lg:grid-cols-2 gap-8">
    //         {feeStructures?.map((structure, index) => (
    //           <div key={index} className="bg-card border border-border rounded-xl p-8 shadow-sm">
    //             <h3 className="text-2xl font-bold text-primary mb-4">{structure?.type}</h3>
    //             <p className="text-text-secondary mb-6">{structure?.description}</p>

    //             <div className="space-y-6">
    //               <div>
    //                 <h4 className="text-sm font-semibold text-primary mb-4 uppercase tracking-wide">
    //                   {structure?.rates ? 'Hourly Rates' : 'Fee Components'}
    //                 </h4>
    //                 <div className="space-y-3">
    //                   {(structure?.rates || structure?.components)?.map((item, idx) => (
    //                     <div key={idx} className="flex justify-between items-center py-2 border-b border-slate-200 last:border-b-0">
    //                       <span className="text-sm text-text-secondary">{item?.service || item?.deliverable}</span>
    //                       <span className="text-sm font-medium text-primary">{item?.rate || item?.fee}</span>
    //                     </div>
    //                   ))}
    //                 </div>
    //               </div>

    //               <div>
    //                 <h4 className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
    //                   Advantages
    //                 </h4>
    //                 <div className="space-y-2">
    //                   {structure?.advantages?.map((advantage, idx) => (
    //                     <div key={idx} className="flex items-start space-x-2">
    //                       <Icon name="Plus" size={14} className="text-emerald-500 flex-shrink-0 mt-0.5" />
    //                       <span className="text-sm text-text-secondary">{advantage}</span>
    //                     </div>
    //                   ))}
    //                 </div>
    //               </div>

    //               <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
    //                 <h5 className="text-sm font-semibold text-primary mb-1">Best For</h5>
    //                 <p className="text-sm text-text-secondary">{structure?.bestFor}</p>
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     )}

    //     {activeTab === 'outcomes' && (
    //       <div className="grid md:grid-cols-2 gap-8">
    //         {caseOutcomes?.map((outcome, index) => (
    //           <div key={index} className="bg-card border border-border rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
    //             <div className="flex items-start justify-between mb-4">
    //               <h3 className="text-lg font-semibold text-primary">{outcome?.caseType}</h3>
    //               <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-medium">
    //                 {outcome?.outcome}
    //               </span>
    //             </div>

    //             <div className="space-y-4">
    //               <div className="flex items-center space-x-2">
    //                 <Icon name="MapPin" size={16} className="text-slate-400" />
    //                 <span className="text-sm text-text-secondary">{outcome?.jurisdiction}</span>
    //               </div>

    //               <div className="bg-emerald-50 border-l-4 border-emerald-400 p-4 rounded-r-lg">
    //                 <h4 className="text-sm font-semibold text-emerald-800 mb-1">Impact</h4>
    //                 <p className="text-sm text-emerald-700">{outcome?.impact}</p>
    //               </div>

    //               <div>
    //                 <h4 className="text-sm font-semibold text-primary mb-3">Success Factors</h4>
    //                 <div className="space-y-2">
    //                   {outcome?.keyFactors?.map((factor, idx) => (
    //                     <div key={idx} className="flex items-start space-x-2">
    //                       <Icon name="Star" size={14} className="text-amber-500 flex-shrink-0 mt-0.5" />
    //                       <span className="text-sm text-text-secondary">{factor}</span>
    //                     </div>
    //                   ))}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     )}

    //     <div className="mt-16 bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-8 lg:p-12 text-center">
    //       <h3 className="text-2xl lg:text-3xl font-bold text-primary mb-4">
    //         Ready to Discuss Your Case?
    //       </h3>
    //       <p className="text-text-secondary mb-8 max-w-2xl mx-auto">
    //         Contact us for a confidential consultation to discuss your litigation support needs. We provide preliminary case assessments within 48 hours.
    //       </p>
    //       <div className="flex flex-col sm:flex-row gap-4 justify-center">
    //         <button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2">
    //           <Icon name="Calendar" size={18} />
    //           <span>Free Consultation</span>
    //         </button>
    //         <button className="border border-orange-300 hover:bg-orange-50 text-orange-700 px-8 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2">
    //           <Icon name="Download" size={18} />
    //           <span>Download Engagement Guide</span>
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </section> */}
    </>
  );
};

export default EngagementSection;